import { Col, Form, Row } from 'antd';
import { Moment } from 'moment';
import React from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { RefreshIcon, SearchIcon } from '@/assets/icons';
import ButtonWrap from '@/components/ButtonWrap';
import FormItemWrap from '@/components/FormItemWrap';
import IconWrap from '@/components/IconWrap';
import InputWrap from '@/components/InputWrap';

// eslint-disable-next-line import/order
import TicketMenu from "@components/TicketMenu";
import RangePickerWrap from '@/components/RangePickerWrap';

import './style.scss';


interface IProps {
    onHandleData: (data: any) => void;
    onClearData: () => void;
}

interface FormValues {
    name: string;
    date: [Moment | null, Moment | null] | null;
}

const Header: React.FC<IProps> = ({ onHandleData, onClearData }) => {
    const { t } = useTranslation(['common', 'ticket']);

    const { control, handleSubmit, reset } = useForm<FormValues>({
        defaultValues: {
            name: '',
            date: null,
        },
    });

    const onSubmit = (data: FormValues) => {
        onHandleData(data);
    };

    const onReset = () => {
        reset({
            name: '',
            date: null,
        });
        onClearData();
    };

    return (
        <div className="p-issue-ticket-header">
            <TicketMenu />
            <Form onFinish={handleSubmit(onSubmit)}>
                <Row gutter={{ xxl: 20 }}>
                    <Col span={24} xxl={16}>
                        <Row gutter={16}>
                            <Col span={8} xxl={{ span: 8 }}>
                                <FormItemWrap labelAlign="left" label={t('ticket:NAME')} colon={false}>
                                    <Controller
                                        name="name"
                                        control={control}
                                        render={({ field }) => <InputWrap field={field} />}
                                    />
                                </FormItemWrap>
                            </Col>
                            <Col span={10} xxl={{ span: 10 }}>
                                <FormItemWrap labelAlign="left" label={t('ticket:VALID_PERIOD')} colon={false}>
                                    <Controller
                                        name="date"
                                        control={control}
                                        render={({ field }) => <RangePickerWrap field={field} suffixIcon="true" />}
                                    />
                                </FormItemWrap>
                            </Col>
                        </Row>
                    </Col>
                    <Col span={24} xxl={8}>
                        <Row gutter={16} justify="end">
                            <Col span={12} xl={{ span: 6, offset: 6 }} xxl={{ span: 10, offset: 0 }}>
                                <ButtonWrap
                                    icon={<RefreshIcon />}
                                    width="100%"
                                    onClick={onReset}
                                    text={`${t('CLEAR')}`}
                                />
                            </Col>
                            <Col span={12} xl={{ span: 6 }} xxl={10}>
                                <ButtonWrap
                                    icon={<IconWrap icon={<SearchIcon />} />}
                                    text={`${t('SEARCH')}`}
                                    type="primary"
                                    width="100%"
                                    htmlType="submit"
                                />
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Form>
        </div>
    );
};

export default Header;
